import { getProjectById } from '../services/onboardingApi';
import { backendProjectToIProject } from '../services/onboardingTransforms';
import type { IProject } from '../redux/slice/userProjectSlice';

/**
 * Resolve the project row for a dashboard URL from navigation state or API.
 */
export async function resolveDashboardProject(
  routeProjectId: number,
  fallback?: IProject | null
): Promise<IProject | null> {
  if (fallback?.project_id === routeProjectId && fallback.project_name) {
    return fallback;
  }

  try {
    const project = await getProjectById(routeProjectId);
    if (project) return backendProjectToIProject(project);
  } catch {
    // Caller handles missing project
  }

  return null;
}
